import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const ProductionFigure = React.lazy(() => import('.'));

export const productionFigureRoutes = [
  new Route({
    path: 'production-figure',
    element: ProductionFigure,
    children: [],
  }),
];
